/**
 * Testimonials slider — self-contained initialiser.
 * Uses global Flickity (loaded via flickity.pkgd.min.js).
 * Compatible with Dawn / non-Archetype build pipelines — no ES module imports.
 */

(function () {
  function initTestimonials(wrapper) {
    const sectionId = wrapper.dataset.sectionId;
    const slider = wrapper.querySelector('#Testimonials-' + sectionId);
    if (!slider || slider._flktyInit) return;
    slider._flktyInit = true;

    const count    = parseInt(slider.dataset.count || '0');
    const autoplay = wrapper.dataset.autoplay !== 'false';
    const speed    = parseInt(wrapper.dataset.speed || '5') * 1000;

    var flkty = new Flickity(slider, {
      adaptiveHeight:       true,
      pageDots:             true,
      prevNextButtons:      false,
      cellAlign:            'center',
      wrapAround:           count > 3,
      autoPlay:             autoplay ? speed : false,
      pauseAutoPlayOnHover: true,
      selectedAttraction:   0.04,
      friction:             0.4
    });

    // Quick nudge after 1 s to hint there are more slides (only when autoplay is off)
    if (!autoplay && count > 2) {
      setTimeout(function () {
        if (flkty) flkty.next();
      }, 1000);
    }
  }

  function tryInit() {
    if (typeof Flickity === 'undefined') {
      var check = setInterval(function () {
        if (typeof Flickity !== 'undefined') {
          clearInterval(check);
          document.querySelectorAll('.testimonials-section[data-section-id]').forEach(initTestimonials);
        }
      }, 50);
      return;
    }
    document.querySelectorAll('.testimonials-section[data-section-id]').forEach(initTestimonials);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', tryInit);
  } else {
    tryInit();
  }
})();
